export enum ProcessStatusEnum {
    VERY_GOOD = 0,
    GOOD = 1,
    BAD = 2,
    VERY_BAD = 3
}
